var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocIconmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.288 11.295l-2.254 2.969a1.268 1.268 0 01-.454.372 1.322 1.322 0 01-1.16 0 1.268 1.268 0 01-.454-.372l-2.253-2.97C1.935 11.68 0 12.54 0 13.54 0 14.898 3.582 16 8 16s8-1.102 8-2.461c0-1-1.934-1.858-4.712-2.244z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 13.539l4.218-5.558a4.856 4.856 0 00.437-5.234A5.102 5.102 0 0010.73.74 5.379 5.379 0 008 0c-.964 0-1.91.257-2.73.741a5.102 5.102 0 00-1.925 2.005 4.857 4.857 0 00.437 5.235L8 13.539zM8 2.792c.458 0 .906.131 1.288.376.38.245.678.593.853 1 .176.407.222.855.132 1.288-.09.432-.31.83-.634 1.14a2.348 2.348 0 01-1.187.61c-.45.087-.916.043-1.34-.126a2.3 2.3 0 01-1.04-.82 2.168 2.168 0 01-.39-1.24c0-.59.244-1.157.679-1.575A2.366 2.366 0 018 2.792z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocIconmin);
export default __webpack_public_path__ + "static/media/LocIcon.min.107699048e33f41afa346f9c4442046b.svg";
export { ForwardRef as ReactComponent };